module.exports = __webpack_public_path__ + "img/0-59.45556246.jpg";